import { binCleaningAddressRoute } from 'route/routeBinCleaning';
import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { ButtonVariant } from '../../button/buttonProps';
import { getNavigationNameForPageEnum, PageEnum } from '../../../route/page';
import { getUrlAdysHomepage } from '../../../config/url';
import { insectControlAddressRoute } from 'route/routeInsectControl';
import { ratControlAddressRoute } from 'route/routeRatControl';
import { ServiceType } from 'common/serviceType';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import adysMan from '../../../assets/adysman/adysman.png';
import OrderTitle from '../../orderTitle';
import OtherServices from 'component/otherServices';
import PageWrapper from 'component/pageWrapper';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import useOrderWasCreated from 'store/order/hook/order/useOrderWasCreated/useOrderWasCreated';
import usePaymentData from '../../../store/order/hook/payment/usePaymentData/usePaymentData';
import usePersonalInformationData from '../../../store/order/hook/personalInformation/usePersonalInformationData/usePersonalInformationData';
import usePostalCodeIsNotInSystem from '../../../store/order/hook/postalCodeIsNotInSystem/usePostalCodeIsNotInSystem/usePostalCodeIsNotInSystem';
import useServiceType from 'store/order/hook/order/useServiceType/useServiceType';

const ContentBoxTop = styled.div``;

interface ContentBoxBottomProps {
    readonly isSmallLayout: boolean;
}

const ContentBoxBottom = styled.div`
    align-self: flex-end;
    margin-top: ${(props: ContentBoxBottomProps) => {
        if (props.isSmallLayout) {
            return '50px';
        }
        return '200px';
    }};
    flex: 1;
    display: flex;
    justify-content: center;
`;

const ContentBoxIn = styled.div`
    height: 100%; ;
`;

const InsectControlSuccessPage: React.FC<{}> = () => {
    const { t } = useTranslation();
    const history = useHistory();

    const orderWasCreated = useOrderWasCreated();
    const serviceType = useServiceType();
    const paymentData = usePaymentData();
    const personalInformationData = usePersonalInformationData();
    const postalCodeIsNotInSystem = usePostalCodeIsNotInSystem();

    const theme = useTheme();
    const isSmallLayout = useMediaQuery(theme.breakpoints.down('sm'));

    const text1a = useMemo<string>(() => {
        if (paymentData?.isPaid === true) {
            return t('order.screen.success.insectControlPaidText', {
                email: personalInformationData === undefined || personalInformationData === null ? '' : personalInformationData.email,
            });
        }
        if (paymentData?.isPaid === false) {
            return t('order.screen.success.insectControlNotPaidText', {
                email: personalInformationData === undefined || personalInformationData === null ? '' : personalInformationData.email,
            });
        }
        if (postalCodeIsNotInSystem) {
            return t('order.screen.success.interestText1PostalConIsNotInSystem');
        }
        return '';
    }, [paymentData?.isPaid, personalInformationData, postalCodeIsNotInSystem, t]);

    if (!orderWasCreated) {
        switch (serviceType) {
            case ServiceType.binsCleaning:
                history.push(binCleaningAddressRoute.url());
                break;
            case ServiceType.ratControl:
                history.push(ratControlAddressRoute.url());
                break;
            case ServiceType.insectControl:
                history.push(insectControlAddressRoute.url());
                break;
            default:
                throw new Error(`unexpected service type ${serviceType}`);
        }
        return null;
    }

    return (
        <PageWrapper
            page={PageEnum.congratulations}
            pageTitle={getNavigationNameForPageEnum(PageEnum.congratulations)}
            serviceType={ServiceType.insectControl}
            price={undefined}
            secondButton={{
                arrowContinue: false,
                onClick: () => {
                    window.location.href = getUrlAdysHomepage();
                },
                text: t('order.navigation.close'),
                variant: ButtonVariant.outlined,
            }}
        >
            <ContentBoxIn>
                <ContentBoxTop>
                    <OrderTitle title={t('order.screen.success.paidTitle')} titleCenter={true} />

                    <Box width={isSmallLayout ? 'auto' : '500px'} margin={'0 auto'}>
                        <Box marginBottom={'16px'}>
                            <Typography
                                align={'center'}
                                style={{
                                    color: 'rgba(0,0,0,0.64)',
                                    fontSize: '18px',
                                }}
                            >
                                {text1a}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography
                        variant={'h2'}
                        style={{
                            paddingTop: 20,
                            paddingBottom: 40,
                            ...(isSmallLayout ? { fontSize: 32 } : {}),
                        }}
                        align="center"
                    >
                        {t('order.screen.success.anyOtherProblem')}
                    </Typography>
                    <OtherServices currentService={ServiceType.insectControl} />
                </ContentBoxTop>
                <ContentBoxBottom isSmallLayout={isSmallLayout}>
                    <img src={adysMan} alt={"Ady'sman"} />
                </ContentBoxBottom>
            </ContentBoxIn>
        </PageWrapper>
    );
};

export default InsectControlSuccessPage;
